export { default } from "./SlicersList"
